<template>
<v-card v-show="shop !== 0" class="dash-card">
    <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
        <v-toolbar-title>
            {{getString('Andamento prenotazioni')}}
        </v-toolbar-title>
         <v-spacer></v-spacer>
        <v-toolbar-side-icon @click="hidden = !hidden">
          <v-icon class="q-text-whitesmoke" :class="{'module-closed' : !hidden}" >arrow_drop_down</v-icon>
        </v-toolbar-side-icon>
    </v-toolbar>
    <v-layout row wrap v-show="!hidden">
        <v-flex xs12 sm12 md12 lg12>
            <v-card>
                 <v-toolbar class="q-whitesmoke-bk q-text-whitesmoke elevation-0 no-cradius" height="50px">
                    <v-layout row style="margin-top:25px">
                        <v-flex xs5>
                            <v-menu ref="dp1" :close-on-content-click="false" v-model="EmployeeCard.dp1" :nudge-right="40" :return-value.sync="EmployeeCard.empDateStart" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <v-text-field slot="activator" v-model="EmployeeCard.empDateStart" :label="getString('Da')" prepend-icon="event" readonly color="red lighten-2"></v-text-field>
                                <v-date-picker :locale="locale" :title-date-format="formatTitle" show-current color="red lighten-2" v-model="EmployeeCard.empDateStart" @input="$refs.dp1.save(EmployeeCard.empDateStart)"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs5>
                            <v-menu ref="dp2" :close-on-content-click="false" v-model="EmployeeCard.dp2" :nudge-right="40" :return-value.sync="EmployeeCard.empDateEnd" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <v-text-field slot="activator" v-model="EmployeeCard.empDateEnd" :label="getString('A')" prepend-icon="event" readonly color="red lighten-2"></v-text-field>
                                <v-date-picker :locale="locale" :title-date-format="formatTitle" show-current color="red lighten-2" v-model="EmployeeCard.empDateEnd" @input="$refs.dp2.save(EmployeeCard.empDateEnd)"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <v-flex slot="activator">
                            <v-btn @click="getEmployeesStats" color="red lighten-2" class="no-cradius elevation-0 q-text-whitesmoke">
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>
                        <span>{{getString('Aggiorna i dati')}}</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                     <v-progress-circular class="full-width q-orange" indeterminate v-show="EmployeeCard.empLoading"></v-progress-circular>
                     <canvas v-show="!EmployeeCard.empLoading" id="chart"></canvas>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</v-card>
</template>

<script>
import moment from 'moment'
import ajax from '../../../ajax'
import Utils from '../../../utils'
import Chart from 'chart.js'
let ut = new Utils()
export default {
  name: 'StatsShopCard',
  mounted: function() {
    
    let self = this
    let ut = new Utils()
    self.createChart('chart')
  },
  computed: {
    locale: function() {
      return this.$store.state.currentTranslator.locale
    },
    dyncamicAlertTime: function() {
      return this.alertText.length * 100 > 3000
        ? this.alertText.length * 100
        : 3000
    },
    isFullscreen: function() {
      return this.$store.state.isFullscreen
    },
    isAdmin: function() {
      return this.$store.getters.isAdmin
    },
    selectedEmpItems: function() {
      let result = []
      let self = this
      if (Object.keys(this.EmployeeCard.resStats).length > 0) {
        this.EmployeeCard.resStats.reservations.forEach(element => {
          if (element[0].ReferenceEmployee === self.EmployeeCard.selectedEmp) {
            result = element
          }
        })
      }
      return result
    },
    chartData: function() {
      return {
        labels: this.EmployeeCard.resStats.weeks,
        datasets: this.EmployeeCard.resStats.data
      }
    }
  },
  data: () => {
    return {
      h: null,
      EmployeeCard: {
        resStats: {
          employees: [],
          weeks: [],
          data: []
        },
        selectedEmp: 0,
        // empDateStart: new Date().getFullYear()+'-'+ut.NumberWith0(new Date().getMonth()+1)+'-'+ ut.NumberWith0(1),
        empDateStart: moment().subtract(1, "year").format("YYYY-MM-DD"),
        empDateEnd:
          new Date().getFullYear() +
          '-' +
          ut.NumberWith0(new Date().getMonth() + 1) +
          '-' +
          ut.NumberWith0(new Date().getDate()),
        dp1: false,
        dp2: false,
        empLoading: false
      },
      hidden: true,
      shop: 0,
      chart: null
    }
  },
  methods: {
    createChart: function(chartId, chartData) {
      const ctx = document.getElementById(chartId).getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'line',
        data: this.chartData,
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }
      })
    },
    formatTitle: function(d) {
      var options = {
        weekday: 'long'
      }
      return ut.Capitalize(new Date().toLocaleString(this.locale, options))
    },
    formatDate: function(date) {
      // return (
      //   date.getFullYear() +
      //   '-' +
      //   ut.NumberWith0(date.getMonth() + 1) +
      //   '-' +
      //   ut.NumberWith0(date.getDate())
      // )
      return date
    },
    setVisibility: function(vis) {
      this.hidden = vis
    },
    getEmployeesStats: function() {
      let self = this
      this.EmployeeCard.empLoading = true
      ajax.axios
        .get(
          ajax.baseUrl() +
            '/admin/dashboard/trends/chart/shop/' +
            self.shop +
            '/start/' +
            self.formatDate(self.EmployeeCard.empDateStart, true) +
            '/end/' +
            self.formatDate(self.EmployeeCard.empDateEnd, true),
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers,self.$store)
          self.EmployeeCard.resStats = response.data.data
          if (Object.keys(self.EmployeeCard.resStats).length > 0) {
            if (self.EmployeeCard.resStats.employees[0] !== undefined) {
              self.EmployeeCard.selectedEmp =
                self.EmployeeCard.resStats.employees[0].IdEmp
            }
          }
          self.EmployeeCard.empLoading = false
          self.chart.data.labels = self.EmployeeCard.resStats.weeks
          self.chart.data.datasets = self.EmployeeCard.resStats.data
          self.chart.update()
        })
        .catch(function(error) {
          self.EmployeeCard.empLoading = false   
          var auth = ajax.checkAuth(error, self.$store, self.$router)
        })
    },
    init: function(shop) {
      this.shop = shop
      if (this.shop !== 0) {
        this.getEmployeesStats()
      }
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key)
      return page
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/backend/pieces/StatsShopCard.vue